import React from "react"
import upperFirst from "lodash/upperFirst"
import cx from "classnames"

import Image from "../image/image"
import LocationItem from "./locationItem"
import FindOutMore from "../findOutMore/findOutMore"
import Label from "../label/label"
import { accessibleContainerAsLink } from "../../helpers/accessibility"
import { useTranslation } from "../../helpers/useTranslation"

import * as styles from "./item.module.scss"

const Item = ({ content, base, preview }) => {
  const { t } = useTranslation()
  const link = `/${base}/${content.category.slug.current}/${content.slug.current}`
  const title = preview?.title || content.title
  const excerpt = preview?.excerpt || content.excerpt
  const image = preview?.logo?.asset || content._rawFeaturedImage?.asset || content.featuredImage?.asset
  const label = preview?.label

  const { isEventLink, eventLocation } = content

  const imgClass = cx({
    [styles.image]: !eventLocation,
    [styles.eventImage]: eventLocation,
  })

  return (
    <li key={title} className={styles.item}>
      {label && <Label className={styles.label} {...label} />}
      <article {...accessibleContainerAsLink(link)}>
        <Image alt="" image={image} className={imgClass} height={140} width={250} fit="cover" />
        <LocationItem {...content} />
        <div className={styles.inner}>
          <header>
            <h2 className={styles.title}>{title}</h2>
          </header>
          {/* added additional wrapper to keep clamp working properly */}
          <div className={styles.flexGrow}>
            <p className={styles.text}>{excerpt}</p>
          </div>
          {!isEventLink && <FindOutMore url={link} styleType="primary" label={upperFirst(t("find out more"))} />}
        </div>
      </article>
    </li>
  )
}

export default Item
